import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";

const TABS = [
  { key: "wms", label: "WMS", icon: "ri-stack-line" },
  { key: "beeline", label: "Beeline", icon: "ri-pulse-line" },
];

const AUTOMATIONS = {
  wms: [
    { key: "email_agent",          title: "Email Agent",                       subtitle: "Notification, Excel", icon: "ri-mail-line" },
    { key: "penny_drop",           title: "Penny Drop",                        subtitle: "Bank verification",   icon: "ri-coin-line" },
    { key: "paysheet_import",      title: "Paysheet Import",                   subtitle: "Excel import",        icon: "ri-file-list-line" },
    { key: "salary_structure_map", title: "Salary Structure Auto Map",         subtitle: "Auto mapping",        icon: "ri-flow-chart" },
    { key: "offer_letter_rollout", title: "Offer Letter Roll Out",             subtitle: "Bulk dispatch",       icon: "ri-send-plane-line" },
    { key: "salary_revision",      title: "Salary Revision Letters",           subtitle: "Auto share with WMS", icon: "ri-refresh-line" },
    { key: "client_creation",      title: "Client Creation",                   subtitle: "Onboarding",          icon: "ri-building-2-line" },
    { key: "branch_creation",      title: "Branch Creation",                   subtitle: "Onboarding",          icon: "ri-git-branch-line" },
    { key: "contract_creation",    title: "Contract Creation",                 subtitle: "Onboarding",          icon: "ri-file-line" },
  ],
  beeline: [
    { key: "tcs_profile_upload",   title: "TCS Profile Uploading",             subtitle: "Profile sync",        icon: "ri-user-line" },
  ],
};

function AutomationActivity() {
  const [activeTab, setActiveTab] = useState("wms");
  const [busyKey, setBusyKey] = useState("");

  useEffect(() => {
    document.title = "Automation Activity | MERAQUI";
  }, []);

  const handleStart = async (item) => {
    setBusyKey(item.key + ":start");
    await new Promise((r) => setTimeout(r, 500));
    setBusyKey("");
    Swal.fire({
      icon: "info",
      title: item.title,
      text: "Automation triggered. Backend integration pending.",
      confirmButtonColor: "#0e479c",
    });
  };

  const handleViewOutput = (item) => {
    Swal.fire({
      icon: "info",
      title: item.title + " — Output",
      text: "Output view will be wired once backend is ready.",
      confirmButtonColor: "#0e479c",
    });
  };

  const handleDownload = (item) => {
    Swal.fire({
      icon: "info",
      title: item.title + " — Download",
      text: "Download will be wired once backend is ready.",
      confirmButtonColor: "#0e479c",
    });
  };

  const cards = AUTOMATIONS[activeTab] || [];

  return (
    <div className="main-content app-content">
      <div className="container-fluid mt-4 automation-activity-page">
        <style>{`
          .automation-activity-page .aa-header {
            background: linear-gradient(135deg,#4f46e5 0%,#7c3aed 100%);
            color:#fff;border-radius:16px;padding:20px 24px;margin-bottom:20px;
            box-shadow:0 10px 25px -10px rgba(79,70,229,.4);
          }
          .automation-activity-page .aa-toggle {
            position:relative;display:inline-flex;background:#eef0f4;
            border-radius:999px;padding:5px;margin-bottom:20px;
            box-shadow:inset 0 1px 3px rgba(0,0,0,.06);
          }
          .automation-activity-page .aa-toggle-slider {
            position:absolute;top:5px;bottom:5px;width:calc(50% - 5px);
            background:linear-gradient(135deg,#0e479c,#0a3a80);
            border-radius:999px;transition:transform .25s cubic-bezier(.4,0,.2,1);
            box-shadow:0 4px 12px -2px rgba(14,71,156,.45);
          }
          .automation-activity-page .aa-toggle-slider.right {transform:translateX(100%);}
          .automation-activity-page .aa-toggle-btn {
            position:relative;z-index:1;display:inline-flex;align-items:center;
            justify-content:center;gap:8px;
            padding:10px 32px;border:0;background:transparent;
            font-weight:600;font-size:14px;color:#6b7280;cursor:pointer;
            transition:color .2s;min-width:140px;
          }
          .automation-activity-page .aa-toggle-btn i {font-size:18px;}
          .automation-activity-page .aa-toggle-btn.active {color:#fff;}
          .automation-activity-page .aa-grid {
            display:grid;gap:18px;
            grid-template-columns:repeat(auto-fill,minmax(300px,1fr));
          }
          .automation-activity-page .aa-card {
            background:#fff;border:1px solid #eef0f4;border-radius:14px;
            padding:18px;transition:.2s;display:flex;flex-direction:column;gap:14px;
            box-shadow:0 14px 32px -8px rgba(15,23,42,.22), 0 4px 12px rgba(15,23,42,.10);
          }
          .automation-activity-page .aa-card:hover {
            transform:translateY(-4px);
            box-shadow:0 28px 56px -12px rgba(15,23,42,.32), 0 10px 22px rgba(15,23,42,.14);
            border-color:#dbeafe;
          }
          .automation-activity-page .aa-card-top {display:flex;align-items:flex-start;gap:12px;}
          .automation-activity-page .aa-icon {
            width:42px;height:42px;border-radius:10px;display:inline-flex;
            align-items:center;justify-content:center;font-size:20px;
            color:#0e479c;background:#eaf0f9;flex-shrink:0;
          }
          .automation-activity-page .aa-title {font-weight:600;color:#111827;font-size:15px;margin:0;}
          .automation-activity-page .aa-subtitle {color:#6b7280;font-size:12px;margin-top:2px;}
          .automation-activity-page .aa-actions {display:flex;gap:8px;flex-wrap:wrap;}
          .automation-activity-page .aa-btn {
            flex:1;min-width:90px;padding:8px 12px;border-radius:8px;border:0;
            font-size:13px;font-weight:600;cursor:pointer;display:inline-flex;
            align-items:center;justify-content:center;gap:6px;transition:.15s;
          }
          .automation-activity-page .aa-btn:disabled {opacity:.6;cursor:not-allowed;}
          .automation-activity-page .aa-btn-start {background:#0e479c;color:#fff;}
          .automation-activity-page .aa-btn-start:hover:not(:disabled) {background:#0a3a80;}
          .automation-activity-page .aa-btn-view {background:#f1f3f6;color:#0e479c;}
          .automation-activity-page .aa-btn-view:hover {background:#e2e8f0;}
          .automation-activity-page .aa-btn-download {background:#f1f3f6;color:#0e479c;}
          .automation-activity-page .aa-btn-download:hover {background:#e2e8f0;}
          .automation-activity-page .aa-btn-icon {flex:0 0 auto;min-width:0;width:36px;padding:8px;}
          .automation-activity-page .aa-btn-icon i {font-size:16px;}
          .automation-activity-page .aa-empty {
            text-align:center;padding:48px 16px;background:#fff;
            border-radius:14px;border:1px dashed #e5e7eb;color:#6b7280;
          }
        `}</style>

        <div className="aa-toggle" role="tablist" aria-label="Automation systems">
          <span className={`aa-toggle-slider ${activeTab === TABS[1].key ? "right" : ""}`}></span>
          {TABS.map((t) => (
            <button
              key={t.key}
              type="button"
              role="tab"
              aria-selected={activeTab === t.key}
              className={`aa-toggle-btn ${activeTab === t.key ? "active" : ""}`}
              onClick={() => setActiveTab(t.key)}
            >
              <i className={t.icon}></i>
              <span>{t.label}</span>
            </button>
          ))}
        </div>

        {cards.length === 0 ? (
          <div className="aa-empty">
            <i className="ri-inbox-line" style={{ fontSize: 36, display: "block", marginBottom: 8 }}></i>
            No automations configured for this system yet.
          </div>
        ) : (
          <div className="aa-grid">
            {cards.map((item) => {
              const isStarting = busyKey === item.key + ":start";
              return (
                <div className="aa-card" key={item.key}>
                  <div className="aa-card-top">
                    <div className="aa-icon">
                      <i className={item.icon}></i>
                    </div>
                    <div style={{ flex: 1 }}>
                      <p className="aa-title">{item.title}</p>
                      <div className="aa-subtitle">{item.subtitle}</div>
                    </div>
                  </div>
                  <div className="aa-actions">
                    <button
                      type="button"
                      className="aa-btn aa-btn-start"
                      onClick={() => handleStart(item)}
                      disabled={isStarting}
                    >
                      {isStarting ? (
                        <>
                          <span className="spinner-border spinner-border-sm" role="status"></span>
                          Starting
                        </>
                      ) : (
                        <>
                          <i className="ri-play-fill"></i> Start
                        </>
                      )}
                    </button>
                    <button
                      type="button"
                      className="aa-btn aa-btn-view"
                      onClick={() => handleViewOutput(item)}
                    >
                      <i className="ri-eye-line"></i> View
                    </button>
                    <button
                      type="button"
                      className="aa-btn aa-btn-download aa-btn-icon"
                      onClick={() => handleDownload(item)}
                      title="Download"
                      aria-label="Download"
                    >
                      <i className="ri-download-2-line"></i>
                    </button>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}

export default AutomationActivity;
